import styled from 'styled-components'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'

export const _FilterView = styled.div`
  position: relative;
  overflow-x: hidden;
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    padding-top: 12px;
  }
`
export const _LargeScreenCloseBtn = styled.button`
  position: absolute;
  top: 8px;
  right: 14px;
  padding: 8px 8px 6px 8px;
  border: none;
  &:hover {
      cursor: pointer;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }
`

export const _StatusFilter = styled.div`
  padding-left: 24px;
  max-width: 464px;
  margin-bottom: 20px;
  margin-top: 16px;
  display: none;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: block;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding-left: 0;
  }
`

export const _FilterTitle = styled.div`
  margin-bottom: 12px;
  line-height: 22px;
  font-weight: 600;
`

export const _ShowFrom768 = styled.div`
   display: ${({ forceShow }) => (forceShow ? 'block' : 'none')};
   @media screen and (max-width: ${BREAK_POINT_MD}) {
     display: block;
   }
`
